import ObjectDefault from "../../../../../../packages/design-system/object/examples/constellation/object-default.tsx";
import ObjectSizes from "../../../../../../packages/design-system/object/examples/constellation/object-sizes.tsx";
import ObjectLabelling from "../../../../../../packages/design-system/object/examples/constellation/object-labelling.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHobject_default_tsx from "!!raw-loader!../../../../../../packages/design-system/object/examples/constellation/object-default.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHobject_sizes_tsx from "!!raw-loader!../../../../../../packages/design-system/object/examples/constellation/object-sizes.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHobject_labelling_tsx from "!!raw-loader!../../../../../../packages/design-system/object/examples/constellation/object-labelling.tsx";
import * as React from 'react';
export default {
  ObjectDefault,
  ObjectSizes,
  ObjectLabelling,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHobject_default_tsx,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHobject_sizes_tsx,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHobject_labelling_tsx,
  React
};